export const API_TREND_ROUTES = {
  TRENDS: '/trends',
  TREND: '/trends/:trendId',
  PIN_TREND: '/trends/:trendId/pinned/:accountId',
  SEND_BRIEF_LAUNCH_EMAIL: '/trends/send-brief-launch-email',
  ALL_NAMES: '/trends/all-names',
};
